module.exports = __webpack_public_path__ + "img/imgbanner1.9bc64ca9.png";